import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import { decodeJwt } from 'jose'

const Home = () => import('@/views/WoningVergoeding.ts.vue')
const Perceel = () => import('@/views/PerceelVergoeding.ts.vue')
const Landing = () => import('@/views/Landing.ts.vue')
const Login = () => import('@/views/Login.ts.vue')
const FAQs = () => import('@/views/FAQs.ts.vue')
const Registration = () => import('@/views/Register.ts.vue')
const PasswordReset = () => import('@/views/PasswordReset.ts.vue')
const IdentityValidation = () => import('@/views/IdentityValidation.ts.vue')
const History = () => import('@/views/History.ts.vue')
const NotFound = () => import('@/views/404.ts.vue')

const router = createRouter({
	history: createWebHistory(import.meta.BASE_URL),
	routes: [
		{
			path: '/',
			name: 'landing',
			component: Landing,
			meta: {
				title: 'Huis' //createI18n.t('home.meta-title'),
			}
		},
		{
			path: '/:catchAll(.*)',
			name: 'not-found',
			component: NotFound,
			meta: {
				title: '404'
			}
		},
		{
			path: '/woning-vergoeding',
			name: 'Home',
			component: Home,
			meta: {
				title: 'Woning Vergoeding' //createI18n.t('home.meta-title'),
			}
		},
		{
			path: '/perceel-vergoeding',
			name: 'Perceel',
			component: Perceel,
			meta: {
				title: 'Perceel Vergoeding' //createI18n.t('home.meta-title'),
			}
		},
		{
			path: '/identity-validation',
			name: 'IdentityValidation',
			component: IdentityValidation,
			meta: {
				title: 'Identiteitsvalidatie' //createI18n.t('identity-validation.meta-title'),
			}
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
			meta: {
				title: 'Log in' //createI18n.t('login.meta-title'),
			}
		},
		{
			path: '/factuuroverzicht',
			name: 'History',
			component: History,
			meta: {
				title: 'Factuuroverzicht'
			}
		},
		{
			path: '/meest-gestelde-vragen',
			name: 'MeestGeseldeVragen',
			component: FAQs,
			meta: {
				title: 'Meest Geselde Vragen'
			}
		},
		{
			path: '/account-registration',
			name: 'Registration',
			component: Registration,
			meta: {
				title: 'Accountregistratie' //createI18n.t('registration.meta-title'),
			}
		},
		{
			path: '/password-reset',
			name: 'PasswordReset',
			component: PasswordReset,
			meta: {
				title: 'Wachtwoord Reset' //createI18n.t('password-reset.meta-title'),
			}
		}
	]
})

router.beforeEach(async (to, _from, next) => {
	document.title = to.meta.title + ' | Windpark Zeewolde'
	if (to.name === 'Registration' && to.query.userKey) {
		if (!store.getters.isLoggedIn) {
			store.commit('setAccountRegistrationKey', to.query.userKey)
			next()
		} else {
			next({ name: 'Home' })
		}
	} else if (to.name === 'PasswordReset' && to.query.token) {
		if (!store.getters.isLoggedIn) {
			store.commit('setPasswordResetKey', to.query.token)
			next()
		} else {
			next({ name: 'Home' })
		}
	} else {
		if (to.name !== 'Login' && !store.getters.isLoggedIn) {
			next({ name: 'Login' })
		} else if (to.name == 'Login' && store.getters.isLoggedIn) next({ name: 'Home' })
		else {
			let navigated = false
			if (store.getters.accessToken) {
				const jwtObject = decodeJwt(store.getters.accessToken)
				if (jwtObject) {
					const d = new Date()
					if (jwtObject.expires && Number.parseInt(jwtObject.expires.toString()) < d.getTime()) {
						next({ name: 'landing' })
						navigated = true
						store.commit('setCurrentUser', {})
					}
				}
			}
			if (!navigated) {
				next()
			}
		}
	}
})

export default router
